import request from "./request";

export default {
  getVerifycode(phoneNumber) {
    return request.post("/user/sms-challenge", { PhoneNumber: phoneNumber });
  },
  register(info) {
    return request.post("/user/reg", info);
  },
  luckdraw(token) {
    return request.get("/vote/luckdraw", {
      headers: {
        Authorization: "jwt " + token
      }
    });
  },
  award(token) {
    return request.get("/vote/receiveluckyproduct", {
      headers: {
        Authorization: "jwt " + token
      }
    });
  },
  getNumber(token) {
    return request.get("/vote/numluckydraw", {
      headers: {
        Authorization: "jwt " + token
      }
    });
  },
  checkRegister(openId) {
    return request.get(`/user/existwxopen?openId=${openId}`);
  }
};
